import { render, staticRenderFns } from "./record-details.vue?vue&type=template&id=66ca5da3&scoped=true&"
import script from "./record-details.vue?vue&type=script&lang=js&"
export * from "./record-details.vue?vue&type=script&lang=js&"
import style0 from "./record-details.vue?vue&type=style&index=0&id=66ca5da3&prod&scoped=true&lang=scss&"
import style1 from "./record-details.vue?vue&type=style&index=1&id=66ca5da3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ca5da3",
  null
  
)

export default component.exports